var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9998 77V1.00023H1V77H76.9998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1496 23.522C58.5846 25.0868 56.047 25.0868 54.482 23.522C52.9168 21.9573 52.9168 19.4205 54.482 17.8559C56.047 16.2912 58.5846 16.2912 60.1496 17.8559C61.7146 19.4205 61.7146 21.9573 60.1496 23.522Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1533 48.1051L67.4623 41.7976C67.9331 41.327 68.2391 40.7168 68.3347 40.058L71.0045 21.638C71.0733 21.1628 71.0303 20.6781 70.8789 20.2224C70.7274 19.7668 70.4717 19.3528 70.1322 19.0133L58.9919 7.87577C58.6522 7.53624 58.2381 7.28064 57.7823 7.12926C57.3265 6.97788 56.8417 6.93491 56.3664 7.00376L37.9419 9.67297C37.283 9.76847 36.6727 10.0743 36.2018 10.545L26.2031 20.5437",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4131 19.3315L2.0467 44.6917C0.841205 45.8969 0.841205 47.8508 2.0467 49.056L28.9418 75.9444C30.1473 77.1496 32.1017 77.1496 33.3071 75.9444L38.3673 70.8854",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4936 73.8074H40.4788C39.3127 73.8074 38.3674 72.8621 38.3674 71.696V57.5615C38.3674 56.3954 39.3127 55.4501 40.4788 55.4501H47.4936C48.6596 55.4501 49.6049 56.3954 49.6049 57.5615V71.696C49.6049 72.8621 48.6596 73.8074 47.4936 73.8074Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3198 75.6896C67.8362 75.6902 68.3415 75.6912 68.8324 75.6929C69.4381 75.6952 70.0273 75.4953 70.5065 75.1249C70.9857 74.7544 71.3276 74.2346 71.478 73.6479L71.4862 73.616C71.9266 71.8956 75.3574 58.5005 75.6656 57.297L75.6781 57.2486C76.1199 55.5237 74.8126 53.8469 73.0316 53.854C72.3693 53.8568 71.6637 53.8588 70.9606 53.8595C67.9546 53.8627 63.2038 53.8659 61.1534 53.8659V44.2669C61.1534 41.8462 57.8111 40.9788 56.6198 43.095L49.605 57.489V71.6324L51.5493 73.4337C53.1438 74.8902 55.2316 75.6987 57.3987 75.6987C58.7233 75.6987 66.9383 75.697 68.174 75.695",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3135 19.6915L76.8573 1.1521",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4934 49.0411L42.1953 25.3439",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6047 55.3499L41.8526 38.1056",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.e74f333f15e1420f3f4769535972556b.svg";
export { ForwardRef as ReactComponent };